/**
 * Whether this submission may be queued to start automatically on the server.
 *
 * All three must hold: the server offers it (appConfig.features.campaignAutoStart), it
 * is a bulk campaign, and the operator ticked the box for this send. Kept free of React
 * so it can be tested directly.
 */
export function wantsAutoStart(currentForm, autoStartEnabled) {
  return Boolean(autoStartEnabled) && currentForm?.testBulk === 'Bulk' && Boolean(currentForm?.autoStart);
}
